import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { PageNames } from 'src/app/configs/page-names.enum';
import {
  AccountService,
  ExcelService,
  OrganizationTransactionsService,
  OrganizationsService,
  ResellersService,
} from 'src/app/core/api/services';
import { AuthService } from 'src/app/core/services/authentication/auth.service';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { UsersService } from '../../../../core/api/services/users.service';
import { FormPageConfig } from '../../../../core/models/form-page-config.model';
import { UserDocumentationFormModule } from '../user-documentation-form/user-documentation-form.module';
import { UserFormModule } from '../user-form/user-form.module';
import { UsersComponent } from '../users.component';

import { PrivateNumberSendLimitFormComponent } from '../../assign-numbers/private-number-send-limit/private-number-send-limit-form/private-number-send-limit-form.component';
import { ResellerOrganizationsComponent } from '../../resellers/reseller-organizations/reseller-organizations.component';
import { UserPrivateNumbersListComponent } from '../user-private-numbers/user-private-numbers.component';
import { UserTransactionsModule } from '../user-transactions/user-transactions.module';
import { UsersImportFromXlsxFormModule } from '../users-import-from-xlsx/users-import-from-xlsx.module';

@Component({
  selector: 'app-reseller-users',
  imports: [
    BaseIndexModule,
    UserFormModule,
    UserDocumentationFormModule,
    UsersImportFromXlsxFormModule,
    UserTransactionsModule,
    UserPrivateNumbersListComponent,
    ResellerOrganizationsComponent,
    PrivateNumberSendLimitFormComponent,
  ],
  templateUrl: './reseller-users.component.html',
})

export class ResellerUsersComponent extends UsersComponent implements OnInit {
  //#region Properties

  pageName = PageNames.resellerUsers;

  /* Binding service endpoints */
  protected currentService = inject(UsersService);
  paginationApiMethodName: string =
    this.currentService.usersGetResellerUsersWithPagination.name;

  modelWithPagination$: Observable<any>;
  items$: Observable<Array<any>>;
  formPageConfig: FormPageConfig<any> = {};
  fontSize: AppFontSize = 'sm';

  //#endregion

  constructor(
    protected authService: AuthService,
    protected accountService: AccountService,
    protected organizationsService: OrganizationsService,
    protected organizationTransactionsService: OrganizationTransactionsService,

    protected excelFileService: ExcelService,
    protected resellersService: ResellersService,
    protected translate: TranslateService
  ) {
    super(
      authService,
      accountService,
      organizationsService,
      organizationTransactionsService,
      excelFileService,
      resellersService,
      translate
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'userName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.mobile,
        name: 'mobile',
        hasSearch: false,
        noSorting: true,
        wrap: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.credit,
        name: 'credit',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isActiveSend`,
        name: 'isActiveSend',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isAdmin`,
        name: 'isAdmin',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isAuthenticated`,
        name: 'isAuthenticated',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.isAuthenticatedMobile,
        name: 'isAuthenticatedMobile',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}parentOrganizationName`,
        name: 'parentOrganizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}roles`,
        name: 'roles',
        hasSearch: true,
        noSorting: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<any> {
    return this.currentService.usersGetResellerUsersWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        mobile: this.mobile,
      },
    });
  }
  //#endregion

}
